import Css from "./style.module.scss";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import React from "react";

const { EMPTY_PLACEHOLDER } = Constants;

const DescriptionCell = ({ documentData }) => {
  const { lineItems, status, recogniseData = {} } = documentData;

  const { uiTexts, documentUpdateActions } = useSelector(getTextsData);

  const extractStatus = status === DataStatuses.TO_EXTRACT;

  const errorState = recogniseData.status === DocumentRecogniseStatuses.ERROR;

  const descriptions = lineItems && [...new Set(lineItems.map(({ description }) => {
    return description.replace(/^\W+$/g, "").trim();
  }).filter(Boolean))];

  const fullContent = extractStatus
    ? (errorState ? documentUpdateActions.recogniseError : uiTexts.processing)
    : descriptions && descriptions.join("; ");

  return <div title={fullContent} className={Css.descriptionContent}>{fullContent || EMPTY_PLACEHOLDER}</div>;
};

export default React.memo(DescriptionCell);
